<template>
    <div>
        <div v-if="isLoading">
            <div class="row">
                <div class="col my-4 text-center">
                    <img class="mx-auto"
                         style="height: 25px;"
                         src="/themes/brekz-2017/img/loading-indicator-l.gif">
                    <b class="ml-1 my-auto">{{ $t("myAccount.loading") }}</b>
                </div>
            </div>
        </div>

        <div v-else>
            <div v-if="allOrders !== null && allOrders.orders && allOrders.orders.length === 0"
                 class="d-flex justify-content-center align-items-center p-5 ">
                <i class="text-center">
                    {{ $t("myAccount.emtpyOrderMessage") }}
                    <div class="mt-3">{{ $t("myAccount.emtpyOrderMessage2") }}
                        <a title="Home"
                           class="text--green"
                           href="/"
                        >
                            <u>{{ $t("myAccount.emtpyOrderMessage3") }}</u>
                        </a>
                        {{ $t("myAccount.emtpyOrderMessage4") }}
                    </div> <!-- todo link niet hardcoded -->
                </i>
            </div>
            <div class="row no-gutters">
                <div class="col-2 account-order__sidebar--margin-top d-none d-lg-block">
                    <div class="account-order__sidebar--timeline"></div>
                </div>

                <div class="col-12 col-lg-10" v-if="allOrders">
                    <div
                        v-for="order in allOrders.orders"
                        class="account__card--wrapper my-4"
                    >
                        <div class="account-order__sidebar--dot d-none d-lg-block"></div>
                        <div class="account__card pt-2 pb-3">
                            <div class="account__border">
                                <div class="account__card--topbar d-flex align-items-center">
                                    <div class="account-order__sidebar d-none d-lg-flex">
                                        <div class="account-order__sidebar--text mr-2"
                                             v-text="order.order_date_timeline"></div>
                                    </div>
                                    <div class="text--green cursor-pointer"
                                         @click="openTrackAndTraceModal(order)">
                                        #{{ order.id_order }}
                                    </div>

                                    <div @click="openTrackAndTraceModal(order)" class="account--status ml-3 py-1 px-3 d-none d-md-block cursor-pointer">
                                        <i class="fas fa-check mr-2 text-gray-mid"
                                           v-if="order.valid"></i>
                                        <i class="fas fa-clock mr-2 text-gray-mid"
                                           v-else></i>
                                        {{ order.state }}
                                    </div>

                                    <div class="d-flex align-items-center ml-auto">
                                        <div v-show="isMobile"
                                             class="mr-3 text--gray-mid">
                                            {{ $t("myAccount.reorder") }}
                                        </div>
                                        <button v-on:click="reorder(order.id_order)"
                                                class="text-center button-brekz button-brekz--rounded button-brekz--yellow button--icon-left text--gray-600">
                                            <i class="fa fa-shopping-cart mr-2"></i>
                                            <span class="d-none d-md-inline-block">{{ $t("myAccount.reorder") }}</span>
                                        </button>
                                    </div>

                                </div>
                            </div>
                            <div
                                v-for="product in order.products"
                                class="py-3 account__card--border-bottom"
                            >
                                <div class="account__card--inner">
                                    <a :title="product.name"
                                       class="account__link"
                                       :href="product.product_link">
                                        <div class="row no-gutters">
                                            <div class="col-3 d-flex justify-content-center">
                                                <img class="image--max-width account-order--image-max-height"
                                                     :src="product.image_link"
                                                     alt="">
                                            </div>
                                            <div class="col-9">
                                                <div class="pl-3">
                                                    <h2 class="account--title font-weight-bold account-order--product-text-margin-bottom"
                                                        v-text="product.name"></h2>
                                                    <div class="row no-gutters account-order--product-text-margin-bottom">
                                                        <div class="col-4 account--text text--gray-mid">
                                                            {{product.attribute_group_name}}{{product.attribute_group_name === '' ? '' : ':'}}
                                                        </div>
                                                        <div class="col-8 text-right account--text ml-auto">
                                                          <span>(&nbsp;</span>
                                                          <span class="account--text text-center" v-text="product.quantity"></span>
                                                          <span class="mr-4">x&nbsp;)</span>{{product.attribute_name}}
                                                        </div>
                                                        <div class="col-8 text-right account--text ml-auto">
                                                            <span v-if="product.attribute_promotion_name === 'op'" class="product-list__item__bonus--green ml-auto">{{ $t('combinationPromotion.op') }}</span>
                                                            <span v-else-if="product.attribute_promotion_name === 'bonus'" class="product-list__item__bonus--red ml-auto">{{ $t('combinationPromotion.bonus') }}</span>
                                                            <span v-else-if="product.attribute_promotion_name === '2plus1free'" class="product-list__item__bonus--red ml-auto">{{ $t('combinationPromotion.twoPlusOneFree') }}</span>
                                                            <span v-else-if="product.attribute_promotion_name === 'minus10percent'" class="product-list__item__bonus--red ml-auto">{{ $t('combination.minusTenPercent') }}</span>
                                                            <span v-else-if="product.attribute_promotion_name === 'minus20percent'" class="product-list__item__bonus--red ml-auto">{{ $t('combination.minusTwentyPercent') }}</span>
                                                            <span v-else-if="product.attribute_promotion_name === 'minus25percent'" class="product-list__item__bonus--red ml-auto">{{ $t('combination.minusTwentyFivePercent') }}</span>
                                                            <span v-else-if="product.attribute_promotion_name === 'minus30percent'" class="product-list__item__bonus--red ml-auto">{{ $t('combination.minusThirtyPercent') }}</span>
                                                            <span v-else-if="product.attribute_promotion_name === 'minus40percent'" class="product-list__item__bonus--red ml-auto">{{ $t('combination.minusFortyPercent') }}</span>
                                                            <span v-else-if="product.attribute_promotion_name === 'minus50percent'" class="product-list__item__bonus--red ml-auto">{{ $t('combination.minusFiftyPercent') }}</span>
                                                            <span v-else-if="product.attribute_promotion_name === 'minus60percent'" class="product-list__item__bonus--red ml-auto">{{ $t('combination.minusSixtyPercent') }}</span>
                                                            <span v-else-if="product.attribute_promotion_name === 'minus70percent'" class="product-list__item__bonus--red ml-auto">{{ $t('combination.minusSeventyPercent') }}</span>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex align-items-center">
                                                        <div class="account--text textext--gray-mid">{{
                                                            $t("myAccount.pricePerUnit") }}:
                                                        </div>
                                                        <div class="account--text-price ml-auto">
                                                            {{product.unit_price_tax_incl}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>

                            <div class="account-invoice account__border d-block">
                                <div class=""
                                     :id="'accordion_' + order.id_order">
                                    <div :id="'collapse_' + order.id_order"
                                         class="account-invoice--inner py-3 collapse"
                                         :data-parent="'#accordion_' + order.id_order"
                                         aria-expanded="false">
                                        <div class="row no-gutters mb-3">
                                            <div class="col-8">
                                                <div class="account--text  text--gray-100">
                                                    {{ $t("myAccount.products") }}
                                                </div>
                                            </div>
                                            <div class="col-4">
                                                <div class="row no-gutters">
                                                    <div class="col">
                                                        <div class="account--text text--gray-100 text-center">
                                                            {{ $t("myAccount.amount") }}
                                                        </div>
                                                    </div>
                                                    <div class="col d-flex justify-content-end">
                                                        <div class="account--text text--gray-100">
                                                            {{ $t("myAccount.price") }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            v-for="product in order.products"
                                            class="row no-gutters mb-3"
                                        >
                                            <div class="col-8">
                                                <div class="account--text"
                                                     v-text="product.name"></div>
                                            </div>
                                            <div class="col-4">
                                                <div class="row no-gutters">
                                                    <div class="col">
                                                        <div class="account--text text-center"
                                                             v-text="product.quantity"></div>
                                                    </div>
                                                    <div class="col d-flex justify-content-end">
                                                        <div class="account--text">{{product.total_price_tax_incl}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mb-3 mt-4">
                                            <div class="d-flex justify-content-between">
                                                <div class="account--text mb-3">{{ $t("myAccount.totalPriceProducts")
                                                    }}:
                                                </div>
                                                <div class="account--text mb-2">{{order.total_products_tax_incl}}</div>
                                            </div>
                                            <div class="d-flex justify-content-between mb-4">
                                                <div class="account--text">{{ $t("myAccount.shipmentCost") }}:</div>

                                                <div class="account--text">{{order.total_shipping_tax_incl}}</div>
                                            </div>
                                            <div class="d-flex justify-content-between account__border pb-4">
                                                <div class="account--text"><strong>{{ $t("myAccount.total") }}:</strong>
                                                </div>
                                                <div class="account--text">
                                                    <strong>{{order.total_paid_tax_incl}}</strong></div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col">
                                                <div class="account--text mb-3 text--gray-mid">
                                                  {{ $t("myAccount.orderDate") }}:
                                                </div>
                                            </div>
                                            <div class="col text-right">
                                                <div class="account--text mb-3" v-text="order.order_date_details"></div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col">
                                                <div class="account--text mb-3 text--gray-mid">{{ $t("myAccount.status") }}:</div>
                                            </div>
                                            <div class="col text-right">
                                                <div class="account--text mb-3" v-text="order.state"></div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col">
                                                <div class="account--text mb-3 text--gray-mid">{{ $t("myAccount.trackAndTraceText") }}:</div>
                                            </div>
                                            <div class="col text-right">
                                                <div class="row" v-for="trackAndTrace in order.tracking">
                                                    <div class="col">
                                                        <div class="account--text mb-3">
                                                            <a class="button-brekz p-0 font-weight-normal link link--blue link--underline"
                                                               :href="trackAndTrace.link"
                                                               target="_blank">
                                                              {{ $t("myAccount.trackAndTrace") }}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row" v-if="order.tracking.length === 0">
                                                    <div class="col">
                                                        <div class="account--text mb-3">
                                                            <button class="button-brekz p-0 font-weight-normal link link--blue link--underline"
                                                                    @click="openTrackAndTraceModal(order)">
                                                              {{ $t("myAccount.trackAndTrace") }}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col">
                                                <div class="account--text mb-3 text--gray-mid">{{ $t("myAccount.paymentMethod") }}:</div>
                                            </div>
                                            <div class="col text-right">
                                                <div class="account--text mb-3" v-text="order.payment_method"></div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col">
                                                <div class="account--text mb-3 text--gray-mid">{{ $t("myAccount.shippedBy") }}:</div>
                                            </div>
                                            <div class="col text-right">
                                                <div class="account--text mb-3" v-text="order.carrier"></div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-12"
                                                 v-if="order.invoice_url">
                                                <i class="far fa-file-pdf text--green mr-2"></i>
                                                <span>
                                                    <a title="Download PDF"
                                                       class="text--sm text--gray-mid"
                                                       :href="order.invoice_url"
                                                       target="_blank"><u>{{ $t("myAccount.downloadInvoice") }} (PDF)</u>
                                                    </a>
                                                </span>
                                            </div>
                                        </div>

                                    </div>
                                    <button @click="collapseMe(order.id_order)"
                                            class="text-center cursor-pointer account-invoice--collapse-button">
                                        <span :id="'invoiceButtonText_' + order.id_order"
                                              class="text--green">{{ $t("myAccount.detailsInvoice") }}</span><i :id="'invoiceButtonIcon_' + order.id_order"
                                                                                                                class="ml-2 fas fa-chevron-down text--gray-mid"></i>
                                        <!--                                        <span class="text&#45;&#45;green">Sluiten</span><i style="color: #757575" class="ml-2 fas fa-chevron-up text&#45;&#45;gray-mid"></i>-->
                                    </button>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>


            </div>
        </div>

        <modal-vue title=":("
                   :show="showErrorModal"
                   @close="showErrorModal = false"
                   width="xs"
                   :buttons='[{text: $i18n.t("myAccount.close"), class: "button-brekz button-brekz--rounded button-brekz--green button--extra-large mx-auto", emit_name: "close"}]'>
            <p class="my-3">{{ $t("myAccount.errorModalText") }}<br/>{{ $t("myAccount.errorModalText2") }}</p>
        </modal-vue>

        <modal-vue :title="$t('myAccount.reorder')"
                   :show="showConfirmationModal && isMobile"
                   @close="closeModal()"
                   @go-to-cart="goToCart()"
                   :buttons='[
                       {
                           text: $i18n.t("myAccount.close"),
                           class: "button button-brekz button-brekz--rounded m-0",
                           emit_name: "close"
                       }, {
                           text: $i18n.t("myAccount.toCart"),
                           class: "button button--extra-large button-brekz button-brekz--yellow button-brekz--rounded m-0",
                           emit_name: "go-to-cart"
                       }
                   ]'>
            <p class="my-3">{{ $t("myAccount.productsInCart") }}</p>
        </modal-vue>

        <modal-vue :title="$t('myAccount.productsInCart')"
                   :show="showConfirmationModal && !isMobile"
                   @close="closeModal()"
                   width="xs"
                   @go-to-cart="goToCart()"
                   :buttons='[
                       {
                           text: $i18n.t("myAccount.close"),
                           class: "button button--extra-large button-brekz button-brekz--yellow button-brekz--rounded my-0 mx-auto text--gray-mid",
                           emit_name: "close"
                       },
                   ]'>
            <p class="my-3" v-html="$t('myAccount.orderInCart')"></p>
            <p class="mb-2" v-html="$t('myAccount.productsInColumn')"></p>
            <div class="d-flex justify-content-center"><i class="fal fa-check-circle fa-5x text--green mb-3"></i></div>
        </modal-vue>

        <modal-vue :title="$i18n.t('myAccount.orderStatus')"
                   :show="showTrackAndTrace"
                   :cancel-if-clicked-outside-modal="true"
                   @close="closeModal()"
                   @cancel="closeModal()"
                   width="xs"
                   :buttons='[
                       {
                           text: $i18n.t("myAccount.close"),
                           class: "button button--extra-large button-brekz button-brekz--green button-brekz--rounded my-0 mx-auto",
                           emit_name: "close"
                       }
                   ]'>
            <p class="mt-3 account-order__track-and-trace-modal--text">{{ $t("myAccount.orderProcess") }}</p>
            <ul class="list-unstyled">
                <li class="mb-3 account-order__track-and-trace-modal--text">
                    <span>- {{ $t("myAccount.paymentWaiting") }}</span>
                    <i v-if="trackAndTraceModelIsAtGivenStep(currentlySelectedOrder, 'payment_complete').done"
                       class="far fa-check-circle ml-2 account-order__track-and-trace-modal--check"></i>
                </li>
                <li class="mb-3 account-order__track-and-trace-modal--text">
                    <span
                        v-if="trackAndTraceModelIsAtGivenStep(currentlySelectedOrder, 'payment_complete').done" >
                        - {{ $t("myAccount.paymentReceived") }}
                    </span>
                    <span
                        class="account-order__track-and-trace-modal--text-grey"
                        v-else >
                        - {{ $t("myAccount.paymentReceived") }}
                    </span>
                    <i v-if="trackAndTraceModelIsAtGivenStep(currentlySelectedOrder, 'payment_complete').done"
                       class="far fa-check-circle ml-2 account-order__track-and-trace-modal--check"></i>
                    <i v-if="trackAndTraceModelIsAtGivenStep(currentlySelectedOrder, 'payment_complete').error"
                       class="far fa-times-circle ml-2 account-order__track-and-trace-modal--check-failed"></i>
                </li>
                <li class="mb-3 account-order__track-and-trace-modal--text">
                    <span :class="{ 'account-order__track-and-trace-modal--text-grey': !trackAndTraceModelIsAtGivenStep(currentlySelectedOrder, 'order_processed').in_progress }">
                        - {{ $t("myAccount.orderCollected") }}
                    </span>
                    <i v-if="trackAndTraceModelIsAtGivenStep(currentlySelectedOrder, 'order_processed').done"
                       class="far fa-check-circle ml-2 account-order__track-and-trace-modal--check"></i>
                </li>
                <li class="mb-3 account-order__track-and-trace-modal--text">
                    <span :class="{ 'account-order__track-and-trace-modal--text-grey': !trackAndTraceModelIsAtGivenStep(currentlySelectedOrder, 'is_shipped').in_progress }">
                        - {{ $t("myAccount.orderSent") }}
                    </span>
                    <i v-if="trackAndTraceModelIsAtGivenStep(currentlySelectedOrder, 'is_shipped').done"
                       class="far fa-check-circle ml-2 account-order__track-and-trace-modal--check"></i>

                    <ul class="list-unstyled pl-2 account-order__track-and-trace-modal--text-small"
                        :class="{ 'account-order__track-and-trace-modal--text-grey': !trackAndTraceModelIsAtGivenStep(currentlySelectedOrder, 'is_shipped').in_progress }">
                        <li>{{ $t("myAccount.followOrder") }}
                            <span v-if="selectedOrderTrackAndTraces.length === 0"
                               class="p-0 font-weight-normal link link--blue link--underline cursor-pointer">
                                {{ $t("myAccount.trackAndTrace") }}
                            </span>
                            <a target="_blank" class="p-0 font-weight-normal link link--blue link--underline"
                               v-for="(trackAndTrace, index) in selectedOrderTrackAndTraces"
                               :href="trackAndTrace.link">
                              {{ $t("myAccount.trackAndTrace") }} <span v-if="selectedOrderTrackAndTraces.length > 1">(#{{ index + 1 }})<br/></span>
                            </a>
                          {{ $t("myAccount.followOrderEnd") }}
                        </li>
                        <li v-if="selectedOrderTrackAndTraces.length > 1"><i>{{ $t("myAccount.multiplePackages") }}</i></li>
                        <li><i>{{ $t("myAccount.trackAndTraceActiveTime") }}</i></li>
                    </ul>
                </li>
                <li class="account-order__track-and-trace-modal--text">
                    <span :class="{ 'account-order__track-and-trace-modal--text-grey': !trackAndTraceModelIsAtGivenStep(currentlySelectedOrder, 'has_arrived').in_progress }">
                        - {{ $t("myAccount.delivered") }}
                    </span>
                    <i v-if="trackAndTraceModelIsAtGivenStep(currentlySelectedOrder, 'has_arrived').done"
                       class="far fa-check-circle ml-2 account-order__track-and-trace-modal--check"></i>
                </li>
            </ul>
        </modal-vue>

        <modal-vue :title="QuantityErrorModalContent.title"
                   :show="showQuantityErrorModal"
                   :centerButtons="true"
                   @close="showQuantityErrorModal = false"
                   :content="QuantityErrorModalContent.content"
                   :buttons='[{ text: QuantityErrorModalContent.button, class: "button-brekz button-brekz--rounded button-brekz--green button--extra-large", emit_name: "close" }]'>
        </modal-vue>

        <reorder-modal :show="showReOrderModal"
                       v-bind:isMobile="isMobile"
                       @close="showReOrderModal = false"
                       @list-updated="showConfirmationModal = true"
                       :original-products="reorderOriginalProducts"
                       :reorder-error="reorderError"
                       :order-id="orderId"
        >
        </reorder-modal>
    </div>
</template>

<script>
    import ReorderModal from '../components/ReorderModal';
    import ModalVue from "./ModalVue.vue";

    export default {
        name: "OrderHistory",
        components: {
            ReorderModal,
            ModalVue,
        },
        props: {
            isMobile: Boolean,
            getOrdersLink: String,
            reorderLink: String,
        },
        data() {
            return {
                count: 0,
                isLoading: true,
                allOrders: null,
                invoiceCollapse: false,
                showErrorModal: false,
                showReOrderModal: false,
                showConfirmationModal: false,
                showQuantityErrorModal: false,
                QuantityErrorModalContent: {
                    button: '',
                    title: '',
                    content: ''
                },
                showTrackAndTrace: false,
                selectedOrderTrackAndTraces: [],
                //cartQuantity: null,

                reorderOriginalProducts: [],
                reorderError: [],
                orderId: 0,
                currentlySelectedOrder: {}
            }
        },
        methods: {
            getOrders() {
                jQuery.ajax(this.getOrdersLink, {
                    type: "GET",
                    success: response => {
                        this.allOrders = response;
                        this.isLoading = false;
                    },
                    error: XMLHttpRequest => {
                        this.showErrorModal = true;
                        this.isLoading      = false;
                    }
                });
            },
            collapseMe(orderId) {
                if (this.invoiceCollapse === false) {
                    this.invoiceCollapse = true;
                    $('#collapse_' + orderId).collapse('show');
                    $('#invoiceButtonText_' + orderId).html(this.$i18n.t("myAccount.close"));
                    $('#invoiceButtonIcon_' + orderId).removeClass('fa-chevron-down');
                    $('#invoiceButtonIcon_' + orderId).addClass('fa-chevron-up');
                } else {
                    this.invoiceCollapse = false;
                    $('#collapse_' + orderId).collapse('hide');
                    $('#invoiceButtonText_' + orderId).html(this.$i18n.t("myAccount.detailsInvoice"));
                    $('#invoiceButtonIcon_' + orderId).removeClass('fa-chevron-up');
                    $('#invoiceButtonIcon_' + orderId).addClass('fa-chevron-down');
                }

            },
            reorder(orderId) {
                let productsInOrder = [];
                this.isLoading      = true;
                for(let i = 0; i < this.allOrders.orders.length; i++) {
                    if (this.allOrders.orders[i].id_order === orderId) {
                        productsInOrder = this.allOrders.orders[i].products;
                        break;
                    }
                }

                if (productsInOrder.length <= 0) {
                    this.showErrorModal = true;
                    this.isLoading      = false;
                    return;
                }

                let objectIDs = [];

                productsInOrder.forEach(function(product){
                    objectIDs.push(product.id_product);
                });

                if (typeof window.aa === 'function') {
                    window.getAlgoliaUserToken().then((userToken) => {
                        const event = {
                            userToken: userToken,
                            index: window.algolia_index,
                            eventName: "Product Added To Cart",
                            objectIDs: objectIDs
                        };

                        window.aa('clickedObjectIDs', event);
                    });
                }


                jQuery.ajax(this.reorderLink, {
                    type: "POST",
                    data: {
                        id_order: orderId,
                        products: productsInOrder
                    },
                    success: response => {
                        let responseDecoded = JSON.parse(response);

                        if (responseDecoded.success) {
                            window.EventBus.$emit('update-cart');
                            document.body.classList.add("modal-vue--open");
                            this.showConfirmationModal = true;
                        } else {

                            if (responseDecoded.mqcError) {
                                window.EventBus.$emit('update-cart');

                                responseDecoded.products.forEach(product => {
                                    product.id_product = product.id;
                                    window.EventBus.$emit('set-quantity', product);
                                } )
                            } else {
                                this.reorderOriginalProducts = JSON.parse(JSON.stringify(productsInOrder));
                                this.reorderError            = responseDecoded;
                                this.orderId                 = orderId;
                                this.showReOrderModal        = true;
                                document.body.classList.add("modal-vue--open");
                            }

                        }

                        this.isLoading = false;
                    },
                    error: XMLHttpRequest => {
                        this.isLoading      = false;
                        this.showErrorModal = true;
                        console.log('reorder call failed', XMLHttpRequest.responseText);
                    }
                });
            },
            goToCart() {
                if (typeof window.pushGAEvent === 'function') {
                    window.pushGAEvent('my_account_proceed_to_checkout', {});

                    setTimeout(() => {
                        document.getElementById('cart-btn').click();
                    }, 250);

                    return;
                }

                document.getElementById('cart-btn').click();
            },
            trackAndTraceModelIsAtGivenStep(order, currentStep) {
                switch (currentStep) {
                    case 'payment_complete':
                        return {
                            'in_progress': true,
                            'error': order.id_current_state === 8,
                            'done': order.id_current_state === 2 || order.id_current_state === 3 || order.id_current_state === 4 || order.id_current_state === 5 || order.id_current_state === 9 || order.id_current_state === 17 || order.id_current_state === 21
                        };
                    case 'order_processed':
                        return {
                            'in_progress': this.trackAndTraceModelIsAtGivenStep(order, 'payment_complete').done,
                            'done': order.id_current_state === 4 || order.id_current_state === 5
                        };
                    case 'is_shipped':
                        return {
                            'in_progress': this.trackAndTraceModelIsAtGivenStep(order, 'order_processed').done,
                            'done': order.id_current_state === 4 || order.id_current_state === 5
                        };
                    case 'has_arrived':
                        return {
                            'in_progress': this.trackAndTraceModelIsAtGivenStep(order, 'is_shipped').done,
                            'done': order.id_current_state === 5
                        };
                    default:
                        return false;
                }
            },
            openTrackAndTraceModal(order) {
                this.showTrackAndTrace           = true;
                this.selectedOrderTrackAndTraces = order.tracking;
                this.currentlySelectedOrder      = order;
                document.body.classList.add("modal-vue--open");
            },
            closeModal() {
                document.body.classList.remove("modal-vue--open");

                if (this.showTrackAndTrace) {
                    this.showTrackAndTrace      = false;
                    this.currentlySelectedOrder = {};
                }
                if (this.showConfirmationModal) {
                    this.showConfirmationModal = false;
                }
            }
        },
        computed: {

        },
        mounted() {
            this.getOrders();
        }
    }
</script>
